import { FC, useEffect } from "react";

import { AuthenticatedLayout } from "../../layouts";
import { BackdropCircularProgress } from "@websential/cosmic-v20";
import { Box } from "@mui/material";
import { DashboardOutlined } from "@mui/icons-material";
import { IAppState } from "../../store/reducers";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export interface ILoadingPage { }
export const LoadingPage: FC<ILoadingPage> = () => {
	const isAdminUser = useSelector(
		(state: IAppState) => state.user.profile.isSuperStatus
	);
	const navigate = useNavigate();

	useEffect(() => {
		if (isAdminUser && isAdminUser === 0) {
			let path = '/logout'
			navigate(path)
		}
	}, [isAdminUser])
	return (
		<Box>

			<AuthenticatedLayout
				pageTitle=""
				pageTitleIcon={<DashboardOutlined />}
				breadcrumbLinks={[]}
				breadcrumbCurrentPageName={"Global Search"}
				mainContents={<BackdropCircularProgress
					open={true}
					testId={""}
				/>}
			/>
		</Box>
	);
};
